const Req = {
  symbol: 'req',
  color: '#000',
  colorIcon() {
    return `<g fill="none"><circle fill="#00E6A0" cx="16" cy="16" r="16"/><path d="M23.073 7.5a.653.653 0 01.477.192l-.006-.006a.65.65 0 01.184.364l.009.104-.007 3.417c0 .449-.178.88-.496 1.197l-4.24 4.227 4.537 4.523a1.689 1.689 0 11-2.383 2.394l-5.735-5.717a1.686 1.686 0 010-2.395l5.022-5.012h-8.498v11.889a1.69 1.69 0 01-1.718 1.718l-.17-.006A1.696 1.696 0 018.5 22.677V9.347c0-1.066.763-1.847 1.796-1.847z" fill="#FFF"/></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7.073 7.5H10.296C9.263 7.5 8.5 8.28 8.5 9.346v13.33a1.697 1.697 0 001.549 1.713l.17.006a1.69 1.69 0 001.718-1.718V10.789l8.498-.001-5.022 5.012a1.686 1.686 0 000 2.395l5.735 5.717a1.689 1.689 0 002.383-2.394l-4.538-4.523 4.24-4.227c.32-.317.498-.748.497-1.197l.007-3.417a.684.684 0 00-.19-.47l-.003.002-.075-.063a.653.653 0 00-.396-.123z"/>`;
  }
};
export default Req;
